import React, { FC, useState } from "react";

import { SettingsIconButton } from "../../../components/button/SettingsIconButton";
import { CheckSvg } from "../../../components/svg/CheckSvg";
import { CloseSvg } from "../../../components/svg/CloseSvg";
import classNames from "classnames";

type Props = {
  defaultValue?: string;
  onSave: (value: string) => void;
  isLoading?: boolean;
  onCancel: () => void;
  placeholder?: string;
  left?: React.ReactNode;
};

export const SettingsFormInput: FC<Props> = ({
  defaultValue,
  onSave,
  onCancel,
  isLoading,
  placeholder,
  left,
}) => {
  const [inputValue, setInputValue] = useState(defaultValue || "");

  return (
    <div className={"px-3"}>
      <div
        className={
          "rounded-xl border border-[#6938EF] bg-[#7A5AF81A] px-3 pb-3 pt-2 shadow-settings-purple"
        }>
        <div
          className={classNames(
            "grid items-center gap-2",
            left
              ? "grid-cols-[48px_1fr_32px_32px]"
              : "grid-cols-[1fr_32px_32px]",
          )}>
          {left}
          <input
            type={"text"}
            className={
              "w-full bg-transparent text-base font-semibold placeholder:text-[#5F758F] focus:outline-none"
            }
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={(e) => {
              // Enter saves like the ✓ button, Escape cancels (QA 2026-10-21).
              if (e.nativeEvent.isComposing) return;
              if (e.key === "Enter") {
                e.preventDefault();
                if (inputValue.trim() && !isLoading) onSave(inputValue);
              } else if (e.key === "Escape") {
                e.preventDefault();
                onCancel();
              }
            }}
            placeholder={placeholder}
          />
          <SettingsIconButton
            disabled={!inputValue.trim() || isLoading}
            onClick={() => onSave(inputValue)}
            colorVariant={"purple"}
            size={"small"}
            icon={<CheckSvg />}
          />
          <SettingsIconButton
            size={"small"}
            onClick={onCancel}
            icon={<CloseSvg />}
          />
        </div>
      </div>
    </div>
  );
};
